import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
// import { Http } from '@angular/http';
// import "rxjs/add/operator/map";

import { ImcpaAppProvider } from '../../../providers/imcpaApp/imcpaApp';
import { CampaignListPage } from '../campaignList/campaignList';

@Component({
  selector: 'page-addCampaign',
  templateUrl: 'addCampaign.html',
  // styleUrls: [ 'addCampaign.scss', '../../theme/variables.scss' ]
})
export class AddCampaignPage {

  public temple = {};

  constructor(public navCtrl: NavController, public navParams: NavParams, public myApp: ImcpaAppProvider) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad TempleDetailsPage');
  }

  addNewTemple(temple){
    this.myApp.addTemple(temple);
    this.navCtrl.push(CampaignListPage);
  }

}



// WEBPACK FOOTER //
// ./src/pages/campaigns/addCampaign/addCampaign.ts